import { Component, Input } from '@angular/core';
import { ClientConsultNoteTask } from '../../../core/models/client-consult-note-task.model';
import { CeReviewTaskContentComponent } from '../ce-review-task-content/ce-review-task-content.component';

@Component({
    selector: 'app-ce-review-client-consult-note-task',
    templateUrl: './ce-review-client-consult-note-task.component.html',
    imports: [CeReviewTaskContentComponent]
})
export class CeReviewClientConsultNoteTaskComponent {
  @Input() clientConsultNoteTask: ClientConsultNoteTask;
}
